
import {
  AgeTagType,
  ProvinceWordItem,
  RegionTagType,
  SurveyCsvData,
} from "@/store/types";
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
import router from "@/router";

const SurveyModule = namespace("survey");
@Options({
  components: {},
  beforeRouteEnter: (to, from, next) => {
    if (
      from.fullPath !== "/survey/what-gender" &&
      from.fullPath !== "/survey/where-live-province" &&
      from.fullPath !== "/survey/reading-volume"
    ) {
      router.replace("/survey/entrance");
    } else {
      next();
    }
  },
})
export default class SurveyWhereLiveRegion extends Vue {
  @SurveyModule.Getter("byAgeTag")
  private byAgeTag!: AgeTagType;

  @SurveyModule.Getter("regionTag")
  private regionTag!: RegionTagType;

  @SurveyModule.Action("updateSurveyGender")
  private updateSurveyGender!: (gender: number) => Promise<void>;

  @SurveyModule.Action("updatePageStateRegionTag")
  private updatePageStateRegionTag!: (
    regionTag: RegionTagType
  ) => Promise<void>;

  @SurveyModule.Action("updateSurveyProvince")
  private updateSurveyProvince!: (province: number) => Promise<void>;

  @SurveyModule.Action("updateIsWhiteout")
  private updateIsWhiteout!: (isWhiteout: boolean) => Promise<void>;

  @SurveyModule.Getter("isWhiteout")
  private isWhiteout!: boolean;

  @SurveyModule.Getter("surveyData")
  private surveyData!: SurveyCsvData;

  public isVisible = false;
  public isFadeOut = false;

  public async mounted() {
    await this.updateIsWhiteout(false);
    window.scrollTo({ top: 0 });
    this.isFadeOut = false;
    this.isVisible = true;
  }

  public async nextPage(tag: RegionTagType) {
    await this.updatePageStateRegionTag(tag);

    if (this.regionTag === "HOKKAIDO") {
      await this.updateIsWhiteout(true);
      await this.updateSurveyProvince(1);
      this.$router.push("/survey/reading-volume");
    } else if (this.regionTag === "ABROAD") {
      await this.updateIsWhiteout(true);
      await this.updateSurveyProvince(48);
      this.$router.push("/survey/reading-volume");
    } else if (this.regionTag === "NOT_ANSWER") {
      await this.updateIsWhiteout(true);
      await this.updateSurveyProvince(49);
      this.$router.push("/survey/reading-volume");
    } else {
      this.isFadeOut = true;
      this.$router.push("/survey/where-live-province");
    }
  }

  public get isHiraganaWord() {
    return this.byAgeTag === "UNDER_10";
  }

  public get titleWord() {
    let word = "お住まいを教えてください。";
    if (this.isHiraganaWord) {
      word = "あなたの すんでいる ところは どこですか。";
    }
    return word;
  }

  public get regionWordList() {
    let list = this.regionWordListKanji;
    if (this.isHiraganaWord) {
      list = this.regionWordListHiragana;
    }
    return list;
  }

  public regionWordListHiragana: Array<{ tag: RegionTagType; word: string }> = [
    {
      tag: "HOKKAIDO",
      word: "ほっかいどう",
    },
    {
      tag: "TOHOKU",
      word: "とうほく ちほう",
    },
    {
      tag: "KANTO",
      word: "かんとう ちほう",
    },
    {
      tag: "CHUBU",
      word: "ちゅうぶ ちほう",
    },
    {
      tag: "KINKI",
      word: "きんき ちほう",
    },
    {
      tag: "CHUGOKU_SHIKOKU",
      word: "ちゅうごく・しこく ちほう",
    },
    {
      tag: "KYUSHU",
      word: "きゅうしゅう ちほう",
    },
    {
      tag: "ABROAD",
      word: "かいがい",
    },
    {
      tag: "NOT_ANSWER",
      word: "こたえない",
    },
  ];

  public regionWordListKanji: Array<{ tag: RegionTagType; word: string }> = [
    {
      tag: "HOKKAIDO",
      word: "北海道",
    },
    {
      tag: "TOHOKU",
      word: "東北地方",
    },
    {
      tag: "KANTO",
      word: "関東地方",
    },
    {
      tag: "CHUBU",
      word: "中部地方",
    },
    {
      tag: "KINKI",
      word: "近畿地方",
    },
    {
      tag: "CHUGOKU_SHIKOKU",
      word: "中国・四国地方",
    },
    {
      tag: "KYUSHU",
      word: "九州地方",
    },
    {
      tag: "ABROAD",
      word: "海外",
    },
    {
      tag: "NOT_ANSWER",
      word: "答えない",
    },
  ];
}
